

import React, { Component } from 'react';
import cx from 'classnames';
import { Button } from '../../../ui-kit';
import '../styles/_style-button.scss';







export default class StyleButton extends Component {
  onToggle = (e) => {
    const { onToggle } = this.props;

    e.preventDefault();

    onToggle();
  };

  render() {
    const { icon, selected } = this.props;

    return (
      <Button
        className={cx({ 'style-button--selected': selected })}
        type="TERTIARY"
        prefix={icon}
        onClick={this.onToggle} />);


  }
}